import Spec from "./Spec";
import { buildFunction } from "./SpecFunctionServices";
import { SpecManager } from "./SpecManager";
import { isAccountingZero } from "../services/mathServices";

export default class SpecFunction extends Spec {
    function: Function;

    toUpdate: boolean = false;

    computedValue: string | number | boolean = null;
    userValue: string | number | boolean = null;

    get value() {
        if (this.userValue === undefined) {
            debugger;
        }
        return this.userValue ?? this.computedValue;
    }

    set value(value: string | number | boolean) {
        if (!this.readonly) {
            this.userValue = value;
            this.onModified();
        } else {
            debugger;
        }
    }

    get toBeIncludedInTheBundle(): boolean {
        return !!this.userValue;
    }

    constructor(key: string, private func: string, specManager: SpecManager) {
        super(specManager, key, true);
        this.initializeFunction(this.func);
        this.toUpdate = true;
    }

    isAccountingZero(value) {
        return isAccountingZero(value);
    }

    setDependencies(dependencies: Spec[], key = null) {
        for (const dependency of dependencies) {
            const internalKey = this.getDependencyKey(dependency, key);
            if (!internalKey) {
                debugger;
                continue;
            }
            this.dependencies[internalKey] = dependency;

            this.toUpdate = true;
            dependency.addImpacted(this);
        }
        this.initializeFunction(this.func);
    }

    initializeFunction(func: string) {
        if (func?.length) {
            const newF = buildFunction(this, func);
            this.function = () => {
                try {
                    // if (this.uniqueKey === "A73:LW") {
                    //     debugger
                    //     this.computedValue = eval(newF)
                    // } else {
                    this.computedValue = eval(newF);
                    // }
                    // if (this.uniqueKey === "2053:HK") {
                    //     console.log("2053:HK", this.computedValue)
                    //     debugger
                    // }
                    return this.computedValue;
                } catch (e) {
                    debugger;
                    console.log({
                        error: "Compute function error",
                        key: this.key,
                        func: newF,
                        e,
                    });
                    return 0;
                }
                // let value = eval(newF)
                // return value
            };
        }
    }

    build() {
        if (this.specManager.readonly || !this.func) {
            return;
        }
        try {
            this.function();
        } catch (error) {
            debugger;
        }
    }

    getValue(): string | number | boolean {
        return this.value;
    }

    setStream(stream: { userValue: string | number | boolean; computedValue: number }) {
        this.userValue = stream.userValue ?? null;
        this.computedValue = stream.computedValue ?? null;
    }

    getStreamValue() {
        return {
            userValue: this.userValue ?? null,
            computedValue: this.computedValue ?? null,
        };
    }

    get originalValue() {
        return this.computedValue;
    }

    resetOriginalValue() {
        this.userValue = null;
    }

    get isUserValue(): boolean {
        return this.userValue !== null;
    }
}
